/* eslint-disable react/prop-types */
import * as React from 'react';
import { CLAIM_STATUS } from '@constants';
import classes from './IssueItem.module.css';
import { ProductItem } from './ProductItem';

export const IssueItem = React.memo(({ claimItem }) => {
  const {
    issueItems = [], claimStatus = '', orderName = '', tracking = '',
  } = claimItem || {};
  let bottomText = '';
  if (claimStatus === CLAIM_STATUS.PENDING) {
    bottomText = 'issue is under review';
  } else if (claimStatus === CLAIM_STATUS.ACCEPT) {
    bottomText = 'Refunded: virtual visa card';
  } else if (claimStatus === CLAIM_STATUS.REJECT) {
    bottomText = 'Reject reason: Not enough evidence';
  }

  // TODO: 确定返回数据内容
  return (
    <section className={classes.issueItem}>
      <section className={classes.title}>{`${orderName} Tracking: ${tracking}`}</section>
      {issueItems.map((item) => (
        <ProductItem item={item} key={item.id} className={classes.product} />
      ))}
      <section className={classes.bottom}>{bottomText}</section>
    </section>
  );
});
